import {Grid, WithStyles, withStyles} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import cn from 'classnames'
import {Trans} from 'react-i18next'
import messages from '../../../../../../../../assets/messages'
import {styles} from '../styles'

type MoneyManagerInfoBadgeProps = WithStyles<typeof styles> & {
  classNames?: {
    text: string,
    background: string,
  },
  name: string
}

const _MoneyManagerInfoBadge = ({classes, classNames, name}: MoneyManagerInfoBadgeProps) => (
  <Grid item className={cn(classes.pending, classes.isDemoArchived, classNames?.background)}>
    <Typography variant='caption' className={cn(classes.pendingText, classNames?.text)}>
      <Trans {...messages.moneyManager} values={{name}} />
    </Typography>
  </Grid>

)

export const MoneyManagerInfoBadge = withStyles(styles, {withTheme: true})(_MoneyManagerInfoBadge)
